import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import AboutHero from "./components/AboutHero";
import AboutIntroSection from "./components/AboutIntroSection";
import AboutCardsSection from "./components/AboutCardsSection";
import AboutOutroSection from "./components/AboutOutroSection";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Über uns | NetBasis International"
        description="Erfahren Sie mehr über NetBasis International – Ihren Branchenexperten für strategische und operative Handelsunterstützung seit 2008."
        ogUrl="https://net-basis.net/de/ueber-uns"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <AboutHero
          texts={{
            title_line1: "Wir machen, dass ",
            title_line2: "sich was bewegt ...",
            subtitle: "... für SIE!",
          }}
        />

        <AboutIntroSection
          texts={{
            h1: 'Ihr erfahrener Partner für nachhaltigen Markterfolg in der DACH-Region. Unter dem Leitmotiv „linking people & business" begleiten wir ausländische ITK-Hersteller von der strategischen Planung bis zur erfolgreichen operativen Umsetzung vor Ort.',
            p1: "NetBasis International wurde Anfang des Jahres 2008 in Düsseldorf gegründet. Seitdem bieten wir ausländischen Herstellern aus der Telekommunikations- und IT-Branche, die ihre Geschäftstätigkeit in die DACH-Märkte ausweiten oder bereits bestehende Aktivitäten intensivieren möchten, umfassende Beratungs- und Handelsunterstützung sowie kompetente Hilfe bei der marktspezifischen Produktentwicklung und Produktanpassung.",
            p2: "Gemeinsam mit unseren Herstellerpartnern beantworten wir alle strategischen Fragen und arbeiten fokussiert an einem zentralen Anliegen: Ihrem Erfolg und den besten Geschäftsresultaten in neuen Märkten!",
            p3: "Zur Erreichung dieses Ziels erhalten ausländische Unternehmen durch uns unmittelbaren Zugriff auf branchenspezifisches Wissen, langjährige Markterfahrung und weitreichende Kontakte. Sie vermeiden kulturelle oder sprachliche Barrieren durch unsere sofortige Präsenz und profitieren von unserer prompten operativen Arbeit an Märkten, Produkten, Partnern und Kunden.",
            strongName: "NetBasis International",
          }}
        />

        <AboutCardsSection
          texts={{
            management_title: "Management",
            management_desc: "Über 30 Jahre Branchen-Expertise: Profitieren Sie von tiefem Marktwissen und langjähriger internationaler Führungserfahrung für Ihren Erfolg in der DACH-Region.",
            core_values_title: "Grundwerte",
            core_values_desc: "Werte, die verbinden: Mit Respekt, Loyalität und höchster Professionalität sichern wir Ihren Erfolg im DACH-Raum – Ihr Projekt ist bei uns in besten Händen.",
            mission_vision_title: "Mission/Vision",
            mission_vision_desc: "Der Mensch macht den Unterschied: Technologie allein bringt keinen Erfolg. In enger Zusammenarbeit führen wir Ihr Projekt zum Erfolg.",
            read_more: "Mehr erfahren",
          }}
          urls={{
            management: "/de/ueber-uns/management",
            core_values: "/de/ueber-uns/grundwerte",
            mission_vision: "/de/ueber-uns/mission-vision",
          }}
        />

        <AboutOutroSection
          texts={{
            strongName: "NetBasis International",
            p4: "Zur Stärkung bestehender Beziehungen sowie zur Gewinnung neuer Kunden und somit zur nachhaltigeren Erschließung neuer Märkte setzen wir auf einen partnerschaftlichen Umgang in allen Bereichen des Vertriebs und Marketings. Dazu gehört auch die gemeinsame Arbeit an anspruchsvollen, den aktuellen Markterfordernissen perfekt angepassten Hardware- und Software-Lösungen.",
            p5: "Sowohl unsere Unternehmensphilosophie als auch unsere ethische Ausrichtung bringen es mit sich, dass sich NetBasis International strategisch auf eine begrenzte Anzahl von kompetenten Herstellerpartnern konzentriert, die innerhalb der Branche nicht in direkter Konkurrenz zueinander stehen. Wir geben der gemeinsamen Entwicklung und einer synergetischen Zusammenarbeit innerhalb der Gruppe ganz bewusst den Vorzug gegenüber unproduktivem Wettbewerb.",
            p6: "All dies bietet maximale Sicherheit für jeden neuen Partner und ist fester Teil des Pakets, das wir Ihnen anbieten, wenn Sie sich für eine erfolgreiche Zusammenarbeit mit uns entscheiden.",
          }}
        />

        {/* Contact CTA */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              Nehmen Sie jetzt direkt Kontakt mit uns auf.
            </h2>
            <Link
              to="/de/kontakt"
              className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-4 font-heading text-sm md:text-base font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Kontaktformular
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}